<template>
  <Dialog
    v-model:visible="visible"
    modal
    header="Load Population Filters"
    class="max-w-[90vw]"
  >
    <DataTable
      v-model:filters="filters"
      v-model:expandedRows="expandedRows"
      :value="populationsInfo"
      paginator
      :rows="10"
      data-key="name"
      filter-display="row"
      :loading="loading"
      :global-filter-fields="['name', 'description']"
    >
      <template #header>
        <div class="flex justify-end">
          <IconField>
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText
              v-model="filters['global'].value"
              placeholder="Keyword Search"
            />
          </IconField>
        </div>
      </template>
      <template #empty> No populations found.</template>
      <Column expander style="width: 5rem" />
      <Column
        v-for="col in columns"
        :key="col.field"
        :sortable="true"
        :field="col.field"
        :header="col.header"
      ></Column>
      <Column style="width: 5rem">
        <template #body="{ data }">
          <Button
            v-tooltip="'open'"
            variant="text"
            icon="pi pi-folder-open"
            rounded
            @click="
              visible = false;
              emit('open-population', data);
            "
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        expansion for {{ slotProps.data.name }}
      </template>
    </DataTable>
  </Dialog>
</template>

<script setup>
import { defineEmits, defineModel, ref } from "vue";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";

const visible = defineModel("visible", { type: Boolean });
const loading = defineModel("loading", { type: Boolean });
const populationsInfo = defineModel("populations", { type: Array });
const emit = defineEmits(["open-population"]);

const expandedRows = ref({});
const columns = ref([
  { field: "name", header: "Name" },
  { field: "description", header: "Description" },
]);

const filters = ref({
  global: { value: null, matchMode: "contains" },
});
</script>

<style></style>
